import { uuid } from './general';

function sameWidthObserver(): void {
  let prependWidth = 0;
  const prependWidths = new Map<string, number>();
  const inputPrependItems = document.querySelectorAll('div.input-group .same-prepend-width') as unknown as HTMLElement[];
  for (const inputPrependItem of inputPrependItems) {
    const prependWidthGroup = inputPrependItem.getAttribute('data-prepend-width-group');
    if (prependWidthGroup) {
      const prependWidth = prependWidths.get(prependWidthGroup);
      if (prependWidth) {
        if (inputPrependItem.getBoundingClientRect().width > prependWidth) {
          prependWidths.set(prependWidthGroup, inputPrependItem.getBoundingClientRect().width);
        }
      } else {
        prependWidths.set(prependWidthGroup, inputPrependItem.getBoundingClientRect().width);
      }
    } else {
      if (inputPrependItem.getBoundingClientRect().width > prependWidth) {
        prependWidth = inputPrependItem.getBoundingClientRect().width;
      }
    }
  }
  for (const inputPrependItem of inputPrependItems) {
    const prependWidthGroup = inputPrependItem.getAttribute('data-prepend-width-group');
    if (prependWidthGroup) {
      inputPrependItem.style.minWidth = prependWidths.get(prependWidthGroup) + 'px';
    } else {
      inputPrependItem.style.minWidth = prependWidth + 'px';
    }
  }

  let appendWidth = 0;
  const appendWidths = new Map<string, number>();
  const inputAppendItems = document.querySelectorAll('div.input-group .same-append-width') as unknown as HTMLElement[];
  for (const inputAppendItem of inputAppendItems) {
    const appendWidthGroup = inputAppendItem.getAttribute('data-append-width-group');
    if (appendWidthGroup) {
      const appendWidth = appendWidths.get(appendWidthGroup);
      if (appendWidth) {
        if (inputAppendItem.getBoundingClientRect().width > appendWidth) {
          appendWidths.set(appendWidthGroup, inputAppendItem.getBoundingClientRect().width);
        }
      } else {
        appendWidths.set(appendWidthGroup, inputAppendItem.getBoundingClientRect().width);
      }
    } else {
      if (inputAppendItem.getBoundingClientRect().width > appendWidth) {
        appendWidth = inputAppendItem.getBoundingClientRect().width;
      }
    }
  }
  for (const inputAppendItem of inputAppendItems) {
    const appendWidthGroup = inputAppendItem.getAttribute('data-append-width-group');
    inputAppendItem.style.minWidth = appendWidthGroup ? appendWidths.get(appendWidthGroup) + 'px' : appendWidth + 'px';
  }

  document.querySelectorAll('div.input-group .same-prepend-width:not(.same-width-observer)').forEach((element) => {
    element.classList.add('same-width-observer');
    new MutationObserver(sameWidthObserver).observe(element, { attributes: true });
  });
  document.querySelectorAll('div.input-group .same-append-width:not(.same-width-observer)').forEach((element) => {
    element.classList.add('same-width-observer');
    new MutationObserver(sameWidthObserver).observe(element, { attributes: true });
  });
}

function textInputObserver(): void {
  document.querySelectorAll('input.form-control[type=text]:not(.has-clear-button):not(.no-clear-button):not([readonly]), input.form-control[type=number]:not(.has-clear-button):not(.no-clear-button):not([readonly]), input.form-control[type=email]:not(.has-clear-button):not(.no-clear-button):not([readonly]), input.form-control[type=search]:not(.has-clear-button):not(.no-clear-button):not([readonly]), input.form-control[type=tel]:not(.has-clear-button):not(.no-clear-button):not([readonly]), input.form-control[type=url]:not(.has-clear-button):not(.no-clear-button):not([readonly])').forEach((textInputItem) => {
    textInputItem.classList.add('has-clear-button');
    let parentItem = textInputItem.parentElement;
    if (!parentItem) {
      return;
    }

    if (!parentItem.classList.contains('input-group')) {
      const wrapper = document.createElement('div');
      wrapper.classList.add('input-group');
      if (textInputItem.classList.contains('form-control-sm')) {
        wrapper.classList.add('input-group-sm');
      }
      textInputItem.classList.forEach((className: string) => {
        if (className.startsWith('m-') || className.startsWith('mt-') || className.startsWith('mb-') || className.startsWith('ms-') || className.startsWith('me-')) {
          textInputItem.classList.remove(className);
          wrapper.classList.add(className);
        }
      });
      parentItem.replaceChild(wrapper, textInputItem);
      wrapper.insertBefore(textInputItem, null);
      parentItem = wrapper;
    }
    const clearButton = document.createElement('button');
    clearButton.classList.add('input-group-text', 'clear-button');
    clearButton.ariaLabel = 'Eingabe leeren';
    clearButton.type = 'button';
    if (!textInputItem.id) {
      textInputItem.id = uuid();
    }
    clearButton.setAttribute('aria-controls', textInputItem.id);

    clearButton.innerHTML = '<i class="fas fa-times"></i>';
    clearButton.addEventListener('click', clearInputByButton, { capture: true });

    parentItem.insertBefore(clearButton, textInputItem.nextSibling);
  });
}

function clearInputByButton(event: Event): void {
  let inputGroupTextElement = event.currentTarget as HTMLElement | null;
  while (!inputGroupTextElement?.classList.contains('input-group-text') && inputGroupTextElement?.parentElement) {
    inputGroupTextElement = inputGroupTextElement.parentElement;
  }
  if (!inputGroupTextElement?.classList.contains('input-group-text')) {
    return;
  }

  let previousInputItem = inputGroupTextElement.previousElementSibling as HTMLInputElement | null;
  while (previousInputItem?.previousElementSibling && previousInputItem.tagName.toLowerCase() !== 'input') {
    previousInputItem = previousInputItem.previousSibling as HTMLInputElement;
  }
  if (!previousInputItem || previousInputItem.tagName.toLowerCase() !== 'input' || previousInputItem.disabled) {
    return;
  }

  event.stopImmediatePropagation();
  setTimeout(() => {
    previousInputItem.value = '';
    previousInputItem.dispatchEvent(new Event('input', { bubbles: true, cancelable: true }));
    previousInputItem.focus();
  });
}

function inputGroupObserver(): void {
  document.querySelectorAll('input.form-control[type="file"]').forEach(
    fileInput => fileInput.ariaLabel = 'Datei auswählen'
  );
}

function buttonObserver(): void {
  document.querySelectorAll('.btn-group:not([role])').forEach(
    btnGroup => btnGroup.role = 'group'
  );
}

function initAutoGrowingTextarea(): void {
  document.querySelectorAll('textarea.auto-grow:not(.auto-grow-initiated)').forEach((textarea) => {
    const minHeight = Number(getComputedStyle(textarea).height.replace('px', ''));
    const func = (): void => {
      (textarea as HTMLTextAreaElement).style.height = '';
      (textarea as HTMLTextAreaElement).style.height = Math.max(textarea.scrollHeight, minHeight) + 'px';
    };
    textarea.addEventListener('input', func);
    textarea.classList.add('auto-grow-initiated');
    func();
  });
}

document.addEventListener('DOMContentLoaded', () => {
  setTimeout(() => sameWidthObserver());
  textInputObserver();
  inputGroupObserver();
  buttonObserver();
  initAutoGrowingTextarea();
  new MutationObserver(() => {
    textInputObserver();
    initAutoGrowingTextarea();
    setTimeout(() => sameWidthObserver());
  }).observe(document, { childList: true, subtree: true, attributes: true, attributeFilter: ['class'] });
});
